/**
 * 获取组件实例（同时可拥有该组件实例的类型）
 * @param _comp 组件
 * @returns
 */
export function useComRef<T extends abstract new (...args: any) => any>(_comp: T) {
  return ref<null | InstanceType<T>>(null)
}
